import { Validator } from './Parser/Visitor';
export class FFieldProvider {
    constructor(source) {
        this._source = source;
    }
    get source() {
        return this._source;
    }
    getField(name) {
        return this.source.getField(name);
    }
}
export class FFieldResolver extends Validator {
    constructor(provider) {
        super();
        this._provider = provider;
        this._fields = new Map();
    }
    get provider() {
        return this._provider;
    }
    get fields() {
        return this._fields;
    }
    getField(offset) {
        return this.fields.get(offset);
    }
    visitFieldLiteralNode(node) {
        const field = this.provider.getField(node.value);
        if (field == null) {
            this.addError(node, `Unknown field ${node.value}`);
        }
        else {
            if (field.type === 'DATA' || field.type === 'MODELCALC') {
                this.fields.set(node.location.start.offset, field);
            }
        }
    }
}
